import React from 'react';
import styled from 'styled-components';
import media from '../../styles/media.style';

export const Container = styled.footer`
  margin: 0 0 20px 20px;
  font-size: 11px;
  line-height: 13px;
  letter-spacing: 0.4px;
  color: #000;

  ${media.tabletP`
    margin: 0 0 20px 40px;
  `};
`;

const BriefFooter = () => <Container>© 2022 SHISEIDO PROFESSIONAL INC. ALL RIGHTS RESERVED.</Container>;

export default BriefFooter;



// WEBPACK FOOTER //
// ./src/components/Footer/BriefFooter.js